var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.079,
    height: 28.915,
    viewBox: "0 0 27.079 28.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "conversion_17085986",
    d: "M27.7,8.157a.689.689,0,0,0-.688-.688h-3.8A4.368,4.368,0,0,0,21.24,5.936a3.442,3.442,0,1,0-4.972,0,4.366,4.366,0,0,0-2.1,1.726,4.366,4.366,0,0,0-2.1-1.726,3.442,3.442,0,1,0-4.972,0A4.368,4.368,0,0,0,5.115,7.468h-3.8a.689.689,0,0,0-.688.688v5.508c0,.008,0,.015,0,.023s.005.02.006.031a.678.678,0,0,0,.211.447s0,.007,0,.009l9.871,8.974v5.2a.689.689,0,0,0,.688.688h5.508a.689.689,0,0,0,.688-.688v-5.2l9.871-8.974s0-.006,0-.009a.678.678,0,0,0,.211-.447c0-.011.006-.02.006-.031s0-.015,0-.023ZM18.754,1.5a2.065,2.065,0,1,1-2.065,2.065A2.068,2.068,0,0,1,18.754,1.5ZM17.836,7.01h1.836a2.986,2.986,0,0,1,2.983,2.983V11.14h-7.8V9.993A2.986,2.986,0,0,1,17.836,7.01ZM9.575,1.5A2.065,2.065,0,1,1,7.51,3.567,2.068,2.068,0,0,1,9.575,1.5ZM8.657,7.01h1.836a2.986,2.986,0,0,1,2.983,2.983V11.14h-7.8V9.993A2.986,2.986,0,0,1,8.657,7.01ZM4.3,9.993v1.836a.689.689,0,0,0,.688.688H23.344a.689.689,0,0,0,.688-.688V9.993a4.3,4.3,0,0,0-.173-1.147h2.468v4.515l-9.871,8.974s0,.006,0,.009a.678.678,0,0,0-.211.447c0,.011-.006.02-.006.031s0,.015,0,.023v4.819H12.1V22.844c0-.008,0-.015,0-.023s-.005-.02-.006-.031a.678.678,0,0,0-.211-.447s0-.007,0-.009L2,13.361V8.845H4.469A4.3,4.3,0,0,0,4.3,9.993Z",
    transform: "translate(-0.625 -0.125)",
    fill: "#5fa25c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage2);
export default __webpack_public_path__ + "static/media/usage-2.f6d2b94eb4caabaa2563c67acf8fe4a4.svg";
export { ForwardRef as ReactComponent };